import React from 'react'

const CompareProducts = () => {
  return (
    <div>CompareProducts</div>
  )
}

export default CompareProducts